<template>
  <div style='max-width: 1000px' class="container">
    <div class='rowBox'>
      <div class='box1'>
        <div><img src='../assets/001.png'></div>
        <div>客户登记</div>
      </div>
      <div class='box1'>
        <div><img src='../assets/002.png'></div>
        <div>入院登记</div>
      </div>
      <div class='box1'>
        <div><img src='../assets/003.png'></div>
        <div>交费登记</div>
      </div>
    </div>
    <div class='rowBox'>
      <div class='box2'>
        <div><img src='../assets/004.png'></div>
        <div>退款登记</div>
      </div>
      <div class='box2'>
        <div><img src='../assets/005.png'></div>
        <div>转房登记</div>
      </div>
      <div class='box2'>
        <div><img src='../assets/006.png'></div>
        <div>外出登记</div>
      </div>
      <div class='box2'>
        <div><img src='../assets/007.png'></div>
        <div>出院登记</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.rowBox{
  overflow: hidden;
  width: 100%;
  margin-top: 60px;
  margin-bottom: 100px;
  .box1{
    width: 33%;
    float: left;
    text-align: center;
    img{
      width: 80px;
      height: 80px;
    }
  }
  .box2{
    width: 25%;
    float: left;
    text-align: center;
    img{
      width: 80px;
      height: 80px;
    }
  }
}
</style>
